module.exports = __webpack_public_path__ + "static/media/YekanBakh-Light.33cffa23.woff";